
import Modal from "../common/Modal/Modal";
import Button from "../Button/Button";

type DeleteAccountModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
};

const DeleteAccountModal = ({ isOpen, onClose, onConfirm, isLoading = false }: DeleteAccountModalProps) => {

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={"Excluir conta?"}
      isDismissable={!isLoading}
    >
        <p className="text-sm text-gray-600 mb-6 text-center">
          {"Essa ação não pode ser desfeita. Todos os seus dados pessoais serão anonimizados permanentemente."}
          <span className="block mt-2">{"Deseja realmente continuar?"}</span>
        </p>
        <div className="flex justify-center gap-4">
          <Button isLoading={isLoading} variant="danger"
            onClick={onConfirm}
            disabled={isLoading}
            className="px-6 py-2"
          >
            {"Sim, excluir"}
          </Button>
          <Button variant="secondary"
            onClick={onClose}
            disabled={isLoading}
            className="px-6 py-2"
          >
            {"Cancelar"}
          </Button>
        </div>
    </Modal>
  );
};

export default DeleteAccountModal;
